export default __webpack_public_path__ + "Logo-removebg-preview.png?939b3d73ed2a87bf17681f4398bab54a";